import { EthereumClient, w3mConnectors, w3mProvider } from "@web3modal/ethereum";
import { jsonRpcProvider } from 'wagmi/providers/jsonRpc'
import { configureChains, createClient } from "wagmi";

import { ethMainNet ,PulseChain} from "../Chains/Chain";
import { walletConnect } from "../Config";
import { Web3Modal } from "@web3modal/react";
import { WagmiConfig } from "wagmi";

const chains = [ethMainNet ,PulseChain];

// const { provider } = configureChains( // Wagmi client
//   chains,
//   [
//     w3mProvider({ projectId: walletConnect }),
//     jsonRpcProvider({
//       rpc: (chain) => {
//         if (chain.id === PulseChain.id) return { http: PulseChain.rpcUrls.default }
//       },
//     }),
//   ],
// );
const wagmiClient = createClient({
  autoConnect: true,
  connectors: w3mConnectors({ projectId: walletConnect, version: "2", appName: "web3Modal", chains }),
  // provider,
});

// Web3Modal Ethereum Client
const ethereumClient = new EthereumClient(wagmiClient, chains);

const WagmiWallet = ({children}) => {
  return (
    <>
      <WagmiConfig client={wagmiClient}>
        {children}
      </WagmiConfig>
      <Web3Modal
        projectId={walletConnect}
        ethereumClient={ethereumClient}
        themeMode='light'
      />
    </>
  );
};

export default WagmiWallet;


export { wagmiClient, walletConnect, ethereumClient }